import { maybe } from "@saleor/misc";
import { Brand } from "@saleor/products/customTypes/Brand";
import { useEffect, useState } from "react";

export default function useBrandUpdate(
  params,
  brands,
  brandsIsLoading: boolean
): [(e) => void, Brand, Brand[]] {
  const [brand, setBrand] = useState<Brand>({ label: "", value: "" });
  const brandChoices = maybe(
    () =>
      brands.map(brand => ({
        label: brand.name,
        value: brand.id
      })),
    []
  );

  const handleBrandChange = e => {
    const updatedBrand = {
      label: brandChoices.filter(b => b.value === e.target.value)[0].label,
      value: e.target.value
    };

    setBrand(updatedBrand);
  };

  const getBrandLabel = brandId =>
    brandId && brandChoices.length
      ? brandChoices.filter(b => b.value === brandId)[0].label
      : "";

  useEffect(() => {
    if (params.brand !== undefined) {
      setBrand({
        label: getBrandLabel(params.brand),
        value: params.brand
      });
    } else {
      const brandId = brands && brands[0] && brands[0].id;

      setBrand({
        label: getBrandLabel(brandId),
        value: brandId
      });
    }
  }, [brandsIsLoading]);

  return [handleBrandChange, brand, brandChoices];
}
